import $ from 'jquery';
export default (props, e) => {
	e.preventDefault();
	$('#'+props.close).trigger('click');
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/closeFilter.js